module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "main demo-master"
  }, [_c('h1', [_vm._v("Demo Section")]), _vm._v(" "), _c('article', {
    staticClass: "content-demo"
  }, [_c('h2', [_vm._v("Icons")]), _vm._v(" "), _c('div', {
    staticClass: "content icons"
  }, _vm._l((_vm.icons), function(icon, key) {
    return _c('span', {
      class: _vm.generateIconName(icon),
      on: {
        "click": function($event) {
          return _vm.copyIcon(key)
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('article', {
    staticClass: "content-demo"
  }, [_c('h2', [_vm._v("Components")]), _vm._v(" "), _c('NotifBar', {
    attrs: {
      "type": "default",
      "title": "Demo",
      "text": "Lorem ipsum..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(" " + _vm._s(_vm.components.bar.default) + " ")]), _vm._v(" "), _c('NotifBar', {
    attrs: {
      "type": "warn",
      "title": "Demo",
      "text": "Lorem ipsum..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(" " + _vm._s(_vm.components.bar.warn) + " ")]), _vm._v(" "), _c('NotifBar', {
    attrs: {
      "type": "danger",
      "title": "Demo",
      "text": "Lorem ipsum..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(" " + _vm._s(_vm.components.bar.danger) + " ")])], 1), _vm._v(" "), _c('article', {
    staticClass: "content-demo"
  }, [_c('h2', [_vm._v("Form Kit")]), _vm._v(" "), _c('form', {
    staticClass: "form-ui default-form-ui",
    attrs: {
      "no-validate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    attrs: {
      "type": "text",
      "name": "name"
    }
  })]), _vm._v(" "), (_vm.errors.has('name')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    staticClass: "ctn-input ctn-icon",
    class: {
      error: _vm.errors.has('search')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    attrs: {
      "type": "text",
      "name": "search",
      "placeholder": "Recherche"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-loupe"
  })]), _vm._v(" "), (_vm.errors.has('search')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('search')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label ctn-icon",
    class: {
      error: _vm.errors.has('search2')
    }
  }, [_c('label', {
    attrs: {
      "for": "search2"
    }
  }, [_vm._v("Recherche")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    attrs: {
      "type": "text",
      "name": "search2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-loupe"
  })]), _vm._v(" "), (_vm.errors.has('search2')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('search2')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container ctn-select ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Mon select")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.optionsSelect
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container ctn-select ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "select2"
    }
  }, [_vm._v("Mon multi-select")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "",
      "multiple": true,
      "options": _vm.optionsSelect
    },
    model: {
      value: (_vm.select2),
      callback: function($$v) {
        _vm.select2 = $$v
      },
      expression: "select2"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61ab06fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Demo.vue
// module id = 1138
// module chunks = 0